import { apiRequest } from "../../services/apiService";
import {
  ADD_USER_FAIL,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  CHANGE_USER_STATUS_FAIL,
  CHANGE_USER_STATUS_REQUEST,
  CHANGE_USER_STATUS_SUCCESS,
  DELETE_USER_FAIL,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  EDIT_USER_FAIL,
  EDIT_USER_REQUEST,
  EDIT_USER_SUCCESS,
  GET_USER_DATA_FAIL,
  GET_USER_DATA_REQUEST,
  GET_USER_DATA_SUCCESS,
  GET_USER_LIST_DATA_FAIL,
  GET_USER_LIST_DATA_REQUEST,
  GET_USER_LIST_DATA_SUCCESS,
} from "../constant";

export const getUserList = (
  data = {
    startingLimit: 0,
    resultsPerPage: 10,
    search: "",
  }
) => {
  return async (dispatch) => {
    //dispatch({ type: GET_USER_LIST_DATA_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/getUserList`,
      data: data,
    });
    if (response) {
      // dispatch({ type: GET_USER_LIST_DATA_SUCCESS, payload: response?.data });

      // dispatch({ type: GET_USER_LIST_DATA_REQUEST, payload: response?.data });
      if (response?.data?.data) {
        const rawData = response?.data?.data;
        dispatch({
          type: GET_USER_LIST_DATA_SUCCESS,
          payload: rawData,
        });
      }
    } else if (error) {
      dispatch({ type: GET_USER_LIST_DATA_FAIL });
    }
  };
};

export const addUser = (data) => {
  return async (dispatch) => {
    dispatch({ type: ADD_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/addUser`,
      data: data,
    });
    if (response) {
      dispatch({ type: ADD_USER_SUCCESS });
      getUserList();
    } else if (error) {
      dispatch({ type: ADD_USER_FAIL });
    }
  };
};

export const editUser = (data) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/updateUser`,
      data: data,
    });
    if (response) {
      dispatch({ type: EDIT_USER_SUCCESS });
      getUserList();
    } else if (error) {
      dispatch({ type: EDIT_USER_FAIL });
    }
  };
};

export const changeStatus = (data) => {
  return async (dispatch) => {
    dispatch({ type: CHANGE_USER_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/changeStatus`,
      data: data,
    });
    if (response) {
      dispatch({ type: CHANGE_USER_STATUS_SUCCESS });
    } else if (error) {
      dispatch({ type: CHANGE_USER_STATUS_FAIL });
    }
  };
};

export const deleteUser = (data) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "DELETE",
      url: `/users/deleteUser`,
      data: data,
    });
    if (response) {
      dispatch({ type: DELETE_USER_SUCCESS });
      getUserList();
    } else if (error) {
      dispatch({ type: DELETE_USER_FAIL });
    }
  };
};


export const userDetail = () => {
  return async (dispatch) => {
    dispatch({ type: GET_USER_DATA_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/getMyProfileData`,
    });
    if (response) {
      dispatch({ type: GET_USER_DATA_SUCCESS, payload: response.data.data });
      getUserList();
    } else if (error) {
      dispatch({ type: GET_USER_DATA_FAIL });
    }
  };
};

export const updateProfileData = (data) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/updateProfileData`,
      data: data,
    });
    if (response) {
      dispatch({ type: EDIT_USER_SUCCESS });
      getUserList();
    } else if (error) {
      dispatch({ type: EDIT_USER_FAIL });
    }
  };
};

export const uploadProfileImage = (file, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_USER_REQUEST });
    const formData = new FormData();
    formData.append("profile_image", file);
    const token = localStorage.getItem("token_id");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_NODE_API_URL}/users/uploadProfileImage`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        }
      );
      const json = await res.json();
      if (json.result === "success") {
        dispatch({ type: EDIT_USER_SUCCESS });
        dispatch(userDetail());
        if (onSuccess) onSuccess();
        return json.data;
      } else {
        dispatch({ type: EDIT_USER_FAIL });
        return null;
      }
    } catch (err) {
      dispatch({ type: EDIT_USER_FAIL });
      return null;
    }
  };
};

export const removeProfileImage = (onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/removeProfileImage`,
    });
    if (response) {
      dispatch({ type: EDIT_USER_SUCCESS });
      dispatch(userDetail());
      if (onSuccess) onSuccess();
      return true;
    } else if (error) {
      dispatch({ type: EDIT_USER_FAIL });
      return false;
    }
  };
};